var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Collector from "../types/Collector";
import { CollectorSetupResultStatus } from "../types/collector-setup-result";
import { BehaviorType, CollectorId } from "../types";
import { Sentry } from "../utils/Sentry";
import { Logger } from "../utils/Logger";
class NavigationCollector extends Collector {
    constructor(options, plasm) {
        super(options, plasm);
        this.logger = new Logger("NavigationCollector");
        this.state = {
            lastUnfocusedShotTakenTime: null,
        };
        this.unfocusedShotsTimersIds = [];
        this.checkAndHandleUnfocused = () => {
            const isPageFocused = document.hasFocus();
            if (this.storedIsPageFocused === isPageFocused) {
                return;
            }
            this.storedIsPageFocused = isPageFocused;
            if (isPageFocused === false) {
                this.handlePageUnfocused();
            }
        };
        this.id = CollectorId.navigation;
        this.storedIsPageFocused = document.hasFocus();
    }
    setupCollector() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.buildSetupResult(CollectorSetupResultStatus.success);
        });
    }
    buildSetupMeta() {
        return {};
    }
    getReady() {
        return __awaiter(this, void 0, void 0, function* () {
            return undefined;
        });
    }
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            this.startWatchUnfocused();
            this.screenshotsCollector = this.plasm.configuredCollectors.find((collector) => collector.id === CollectorId.screen);
        });
    }
    startWatchUnfocused() {
        if (this.unfocusCheckTimerId != null) {
            clearInterval(this.unfocusCheckTimerId);
        }
        this.unfocusCheckTimerId = setInterval(this.checkAndHandleUnfocused, NavigationCollector.UNFOCUSED_CHECK_INTERVAL);
    }
    handlePageUnfocused() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.plasm.debug("unfocused");
                if (this.unfocusPubSubEvent != null) {
                    this.unfocusPubSubEvent.addLog(new Event(this.unfocusPubSubEvent.id), this.unfocusPubSubEvent.id);
                }
                const { screenshotsMinInterval } = this.plasm.config;
                const shouldRecordUnfocusedShots = this.options.enableUnfocusedShots &&
                    this.screenshotsCollector != null &&
                    this.screenshotsCollector.state.isShotsLimitReached === false &&
                    (this.state.lastUnfocusedShotTakenTime == null ||
                        this.state.lastUnfocusedShotTakenTime + screenshotsMinInterval <= Date.now());
                if (shouldRecordUnfocusedShots) {
                    yield this.initUnfocusedShots();
                }
            }
            catch (err) {
                this.logger.error(err);
                Sentry.captureError(err);
            }
        });
    }
    initUnfocusedShots() {
        return __awaiter(this, void 0, void 0, function* () {
            this.clearUnfocusedShotsTimers();
            yield this.delayUnfocusedShots();
            const shotsCount = this.plasm.config.unfocusedShotsMaxIterations;
            const shotsInterval = this.plasm.config.unfocusedShotsInterval;
            this.state.lastUnfocusedShotTakenTime = Date.now() + (shotsCount - 1) * shotsInterval;
            for (let i = 0; i < shotsCount; i += 1) {
                const delay = shotsInterval * i;
                if (delay === 0 && i === 0) {
                    this.screenshotsCollector.drawAndSendImage({ trigger: "unfocus" });
                }
                else {
                    const timeoutId = setTimeout(() => {
                        if (document.hasFocus() === false) {
                            this.screenshotsCollector.drawAndSendImage({ trigger: "unfocus" });
                        }
                    }, delay);
                    this.unfocusedShotsTimersIds.push(timeoutId);
                }
            }
        });
    }
    clearUnfocusedShotsTimers() {
        this.unfocusedShotsTimersIds.forEach((timeoutId) => clearTimeout(timeoutId));
        this.unfocusedShotsTimersIds = [];
    }
    delayUnfocusedShots() {
        return __awaiter(this, void 0, void 0, function* () {
            const shotsDelay = this.plasm.config.unfocusedShotsDelay;
            if (shotsDelay > 0) {
                yield new Promise((resolve) => {
                    setTimeout(resolve, shotsDelay);
                });
            }
        });
    }
    stopInner() {
        return __awaiter(this, void 0, void 0, function* () {
            this.stopTimers();
        });
    }
    stopTimers() {
        if (this.unfocusCheckTimerId != null) {
            clearInterval(this.unfocusCheckTimerId);
        }
        this.unfocusedShotsTimersIds.forEach((timeoutId) => clearTimeout(timeoutId));
    }
    setPubSubEventCollector(pubSubEvent) {
        if (pubSubEvent.id === BehaviorType.unfocus) {
            this.unfocusPubSubEvent = pubSubEvent;
        }
    }
}
NavigationCollector.UNFOCUSED_CHECK_INTERVAL = 500;
export default NavigationCollector;
